import { Spacing } from '@persona-id/design-tokens';
import { ChevronRightIcon, ChevronUpIcon } from '@persona-id/design-tokens/icons';
import { useState } from 'react';
import styled from 'styled-components';

import TableCell from 'design-system/components/Table/TableCell';
import { FieldSchema, FieldSchemaHash, FieldsMap, FieldType } from 'lib/fields';

import { renderFieldComponent, transformKeyToLabel, ValueType } from './FormUpdateAccountNew';

const CollapsibleHeader = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const CollapsibleLabel = styled.span`
  padding: ${Spacing[2]};
`;

const ChevronContainer = styled.span<{ level: number }>`
  display: inline-flex;
  align-items: center;
  margin-left: ${(props) => (props.level === 0 ? '9px' : '13px')};
`;

const HashTableCell = styled(TableCell)<{ level: number }>`
  padding-left: ${(props) => `${props.level * 20}px`};
`;

const HashSubTableCell = styled(TableCell)<{ level: number }>`
  padding-left: ${(props) => `${(props.level + 1) * 22 + 12}px`};
`;

interface HashFieldComponentProps {
  field: FieldsMap;
  hashSchema: FieldSchemaHash;
  path: string[];
  onChange: (path: string[], value: ValueType) => void;
  isDisabled: boolean;
  level: number;
}

const HashFieldComponent = ({
  field,
  hashSchema,
  path,
  onChange,
  isDisabled,
  level,
}: HashFieldComponentProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleChange = (subPath: string[], value: ValueType) => {
    onChange([...path, ...subPath], value);
  };

  return (
    <>
      <tr>
        <HashTableCell colSpan={2} level={level}>
          <CollapsibleHeader
            id={`hash-field-component_${path.join('_')}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <ChevronContainer level={level}>
              {isOpen ? <ChevronUpIcon /> : <ChevronRightIcon />}
            </ChevronContainer>
            <CollapsibleLabel>
              {hashSchema.label || transformKeyToLabel(path[path.length - 1])}
            </CollapsibleLabel>
          </CollapsibleHeader>
        </HashTableCell>
      </tr>
      {isOpen &&
        Object.entries(field.value).map(([key, subField]) => {
          const newPath = [key];
          const subSchema: FieldSchemaHash = hashSchema.config['item-schemas'].find(
            (schema: FieldSchema) => schema.key === key,
          ) as FieldSchemaHash;

          if (subField.type === FieldType.Hash) {
            return (
              <HashFieldComponent
                key={newPath.join('.')}
                field={subField}
                hashSchema={subSchema}
                path={[...path, ...newPath]}
                onChange={onChange}
                isDisabled={isDisabled}
                level={level + 1}
              />
            );
          }

          return (
            <tr key={newPath.join('.')}>
              <HashSubTableCell level={level}>
                {subSchema.label || transformKeyToLabel(key)}
              </HashSubTableCell>
              <TableCell>
                {renderFieldComponent(
                  subField.value,
                  subField.type,
                  handleChange,
                  () => {},
                  isDisabled,
                  subSchema,
                  newPath,
                  newPath[newPath.length - 1],
                )}
              </TableCell>
            </tr>
          );
        })}
    </>
  );
};

export default HashFieldComponent;
